import tmhRequest from '@/config/tmhRequest'

export default {
    searchRechargeOrderReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/rechargeorderreport/searchrechargeorderreportcount',
            method: 'post',
            data: data,
        })
    },
    searchRechargeOrderReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/rechargeorderreport/searchrechargeorderreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportRechargeOrderReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/rechargeorderreport/exportrechargeorderreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/rechargeorderreport.js